import React from 'react';
import { EnvelopeSimple } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const EmailBookingsSection = ({ emailBookings, onImportBooking }) => {
  if (!emailBookings || emailBookings.length === 0) return null;

  return (
    <div className="mb-8" data-testid="email-bookings-section">
      <div className="flex items-center gap-2 mb-4">
        <EnvelopeSimple weight="duotone" className="w-5 h-5 text-[#4B5945]" />
        <h2 className="font-heading text-xl font-semibold text-[#1A1918]">Found Bookings from Email</h2>
      </div>
      <div className="space-y-3">
        {emailBookings.map((booking, idx) => (
          <div key={booking.email_id || idx} className="card-elevated p-4 flex items-center justify-between" data-testid={`email-booking-${idx}`}>
            <div>
              <p className="font-medium text-[#1A1918]">{booking.restaurant_name}</p>
              <p className="text-sm text-[#7A7873]">
                {booking.booking_date && new Date(booking.booking_date).toLocaleDateString('en-ZA', { weekday: 'short', day: 'numeric', month: 'short' })}
                {booking.booking_time && ` at ${booking.booking_time}`}
                {booking.party_size && ` · ${booking.party_size} guests`}
              </p>
              {booking.matched_restaurant && (
                <p className="text-xs text-[#4B5945]">Matches: {booking.matched_restaurant.name}</p>
              )}
            </div>
            <Button
              onClick={() => onImportBooking(booking)}
              size="sm"
              className="btn-primary"
              data-testid={`import-booking-${idx}`}
            >
              Import
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EmailBookingsSection;
